import { render, staticRenderFns } from "./ResetUsersPasswordDialog.vue?vue&type=template&id=c7a8cb2c&scoped=true&"
import script from "./ResetUsersPasswordDialog.ts?vue&type=script&lang=ts&"
export * from "./ResetUsersPasswordDialog.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Groups/add-user-dialog.scss?vue&type=style&index=0&id=c7a8cb2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7a8cb2c",
  null
  
)

export default component.exports